import { GenericErrorBoundary } from "./GenericErrorBoundary";
import { BaseErrorBoundaryProps, FormContext, createFormState } from "./types";

interface Props extends BaseErrorBoundaryProps, FormContext {}

export function MultiStepFormStepErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="MultiStepFormStep"
      errorBoundaryName="MultiStepFormStepErrorBoundary"
      componentType="FormStep"
      title="Form Step Error"
      description="This form step encountered an error. Please reload the page to continue with your document creation."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createFormState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
